<template lang="pug">
    select-option(:predefined="onMatchOption(item)" :options="options" @value="onValue")
</template>

<script>
//Components
import SelectOption from '@/components/common/forms/select-option';
//Store
import { UsersNameSpace, UsersActionTypes } from '@/store/users/types';
//Configs
import { USER_ROLES } from '@/configs/user-roles';
import { USER_GROUPS } from '@/configs/user-groups';

export default {
    name: 'DefaultUserField',
    components: {
        'select-option': SelectOption,
    },
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        field: {
            type: String,
            default: 'role',
        },
    },
    data() {
        return {
            value: null,
        }
    },
    computed: {
        role() {
            return USER_ROLES
        },
        group() {
            return USER_GROUPS
        },
        options() {
            if (this.field === 'role') {
                return this.role.filter((item) => item.value === 2 || item.value === 3 || item.value === 6)
            }
            if (this.field === 'group' && Number(this.item.role) === 3) {
                return this.group.filter((item) => item.value !== 1)
            }
            return this[this.field]
        }
    },
    methods: {
        async onUserChange({ id, value }) {
            await this.$store.dispatch(`${UsersNameSpace}/${UsersActionTypes.EditUser}`, { id, value })
        },
        onSave({ _id, value }) {
            this.onUserChange({ id: _id, value })
        },
        onMatchOption(item) {
            if (item[this.field]) {
                return this[this.field].find(r => { return r.value === item[this.field] }).name
            }
        },
        onValue(value) {
            const selected = this[this.field].find(r => { return r.name === value }).value
            this.value = selected
            const payload = { [this.field]: selected }
            if (this.field === 'role' && selected === 3) {
                payload.group = 7
            }
            this.onSave({ _id: this.item._id, value: payload })
        },
    },
}
</script>